<!-- Transfer.vue -->
<template>
  <div class="transfer-container">
    <!-- 左侧：源列表 -->
    <div class="transfer-panel">
      <div class="transfer-header">
        <span>{{ leftTitle }}</span>
      </div>
      <div class="transfer-body">
        <div
          class="transfer-checkbox-group"
          ref="scrollLeftContainer"
          @scroll="leftScroll"
        >
          <el-tree
            lazy
            :load="loadNode"
            node-key="id"
            :props="defaultProps"
            ref="myTree"
            v-if="renderTree"
          >
            <span
              class="custom-tree-node"
              slot-scope="{ node, data }"
              @click="
                node.level > 1 && !data.disabled
                  ? changeLeftFn(!isSelected(data.id), data)
                  : ''
              "
            >
              <input
                type="checkbox"
                :value="data.id"
                :checked="isSelected(data.id)"
                :disabled="disabled || data.disabled"
                v-if="node.level > 1"
              />
              <span>{{ data.label }}</span>
            </span>
          </el-tree>

          <span v-if="leftLoading" class="loading">加载中...</span>
          <span v-else-if="!hasLeftMore" class="no-more">没有更多了</span>
        </div>
      </div>
    </div>

    <!-- 中间操作按钮 -->
    <div class="transfer-operation">
      <button
        type="button"
        class="transfer-button transfer-button-right"
        :disabled="disabled || selectedIds.length === 0 || transfering"
        @click="moveToRight"
        title="添加"
      >
        &gt;
      </button>
      <button
        type="button"
        class="transfer-button transfer-button-left"
        :disabled="disabled || selectedShareIds.length === 0 || transfering"
        @click="moveToLeft"
        title="移除"
      >
        &lt;
      </button>
    </div>

    <!-- 右侧：目标列表 -->
    <div class="transfer-panel">
      <div class="transfer-header">
        <span>{{ rightTitle }}</span>
      </div>
      <div class="transfer-body">
        <div v-if="shareList.length === 0" class="transfer-empty">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <div
          v-else
          class="transfer-checkbox-group"
          ref="scrollRightContainer"
          @scroll="rightScroll"
        >
          <label
            v-for="item in shareList"
            :key="item.id"
            class="transfer-checkbox-item"
          >
            <input
              type="checkbox"
              :value="item.id"
              :checked="selectedShareIds.includes(item.id)"
              :disabled="disabled"
              @change="changeRightFn($event.target.checked, item)"
            />
            <span :class="selectedShareIds.includes(item.id) ? 'selected' : ''"
              >{{ item.shareGbCode }}（{{ item.shareName  }}）</span
            >
            <span class="action_btn" @click="editNode(item)">
              <el-button type="text" size="mini"> 编辑 </el-button>
            </span>
          </label>

          <span v-if="rightLoading" class="loading">加载中...</span>
          <span v-else-if="!hasRightMore && shareList.length" class="no-more"
            >没有更多了</span
          >
        </div>
      </div>
      <div class="transfer-footer">
        <button
          type="button"
          class="btn btn-link"
          :disabled="disabled"
          @click="selectAll('right')"
        >
          {{ isAllRightSelected ? "取消全选" : "全选" }}
        </button>
      </div>
    </div>

    <HandleShareDeviceDlg
      v-if="showHandle"
      :row="row"
      @close="showHandle = false"
      @success="successFn"
    />
  </div>
</template>

<script>
import HandleShareDeviceDlg from "../dialog/HandleShareDeviceDlg.vue";

function debounce(fn, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
export default {
  name: "Transfer",
  props: {
    leftTitle: {
      type: String,
      default: "备选项",
    },
    rightTitle: {
      type: String,
      default: "已选项",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    treeData: {
      type: Array,
      default: () => [],
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    HandleShareDeviceDlg,
  },
  data() {
    return {
      leftPage: 1,
      leftTotal: 0,
      hasLeftMore: true,
      leftLoading: false,
      leftLastScrollTop: 0, // 记录上次滚动位置
      rightPage: 1,
      rightTotal: 0,
      hasRightMore: true,
      rightLoading: false,
      rightLastScrollTop: 0, // 记录上次滚动位置
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
      },
      selectedIds: [],
      selectedDatas: [],
      shareList: [],
      selectedShareIds: [],
      showHandle: false,
      row: {},
      transfering: false,
      renderTree: true,
      lastTreeKey: null,
    };
  },
  computed: {
    leftSelectedCount() {
      return this.selectedIds.length;
    },
    rightSelectedCount() {
      return this.selectedShareIds.length;
    },

    isAllRightSelected() {
      return this.selectedShareIds.length === this.shareList.length;
    },
  },
  mounted() {
    this.getShareList();
  },
  methods: {
    // 获取已经共享的列表
    getShareList(more = false) {
      this.rightLoading = more;
      this.$axios({
        method: "get",
        url: "/api/share/devices/get",
        params: {
          page: this.rightPage,
          step: 30,
          sharePlatformId: this.$route.params.sharePlatformId,
          token: this.$cookies.get("session").token,
        },
      })
        .then((res) => {
          if (res && res.data && res.data.code == 0) {
            const { devices = [] } = res.data.data;
            if (!more) {
              this.shareList = [];
            }
            this.shareList = [...this.shareList, ...devices];
            this.hasRightMore = !!devices.length;
          } else {
            this.shareList = [];
            this.hasRightMore = false;
            this.$message.error(res.data.msg || "获取失败");
          }
        })
        .finally(() => {
          this.rightLoading = false;
        });
    },
    isSelected(key) {
      return this.selectedIds.includes(key);
    },
    selectAll(side) {
      if (this.isAllRightSelected) {
        this.selectedShareIds = [];
        return;
      }
      this.selectedShareIds = this.shareList.map((el) => el.id);
    },

    moveToRight() {
      if (this.selectedIds.length === 0) return;
      const devices = this.selectedDatas.map((el) => {
        return {
          id: 0,
          pid: 0,
          shareGbCode: el.gbCode,
          deviceChannelId: el.id,
          sharePlatformId: Number(this.$route.params.sharePlatformId),
          shareName: el.channelName,
          deviceType: 0,
        };
      });
      const params = {
        devices,
      };
      this.transfering = true;
      this.$axios({
        method: "post",
        url: `/api/share/devices/add`,
        data: params,
        params: {
          token: this.$cookies.get("session").token,
        },
      })
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.$message({
              message: res.data.msg || "添加成功",
              type: "success",
            });
            this.hasRightMore = true;
            this.rightPage = 1;
            this.getShareList();
            this.selectedIds = [];
            this.selectedDatas = [];
            this.renderTree = false;
            this.$nextTick(() => {
              this.leftPage = 1;
              this.hasLeftMore = true;
              this.renderTree = true;
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.transfering = false;
        });
    },

    moveToLeft() {
      if (this.selectedShareIds.length === 0) return;
      const params = {
        deviceIds: this.selectedShareIds,
      };
      this.transfering = true;
      this.$axios({
        method: "post",
        url: `/api/share/devices/delete`,
        data: params,
        params: {
          token: this.$cookies.get("session").token,
        },
      })
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.rightPage = 1;
            this.getShareList();
            this.selectedShareIds = [];
            this.$message({
              showClose: true,
              message: res.data.msg || "移除成功",
              type: "success",
            });
            this.renderTree = false;
            this.$nextTick(() => {
              this.leftPage = 1;
              this.hasLeftMore = true;
              this.renderTree = true;
            });
          } else {
            this.$message({
              message: res.data.msg || "移除失败",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.transfering = false;
        });
    },
    // 获取父节点
    async loadNode(node, resolve) {
      if (node.level === 0) {
        const result = await this.getParentNode();
        resolve(result);
        return;
      } else if (node.level === 1) {
        const result = await this.childrenData(node.data);
        resolve(result);
        return;
      }
      resolve([]);
    },
    //获取父节点数据
    getParentNode(more = false) {
      return new Promise((resolve) => {
        this.$axios({
          method: "get",
          url: `/api/devices/query`,
          params: {
            page: this.leftPage,
            step: 150,
            sharePlatformId: this.$route.params.sharePlatformId,
            token: this.$cookies.get("session").token,
          },
        }).then((res) => {
          if (res && res.data.code === 0) {
            const { devices = [], hasNextPage = false } = res.data.data;
            const list = devices.map((el) => {
              return {
                ...el,
                children: [],
                label: el.name,
                leaf: false,
                id: generateUUID(),
              };
            });
            if (this.leftPage === 1) {
              this.lastTreeKey = list[list.length - 1].id;
            }
            this.hasLeftMore = !!list.length;
            if (more && list.length) {
              // 添加树节点
              this.insertAfter(list);
            }
            this.leftLoading = false;
            resolve(list);
          }
        });
      });
    },
    // 插入节点
    insertAfter(data = []) {
      const list = data.map((el) => {
        return {
          ...el,
          children: [],
          label: el.name,
          leaf: false,
          id: generateUUID(),
        };
      });
      const lastNode = this.$refs.myTree.getNode(this.lastTreeKey);
      list.forEach((el) => {
        this.$refs.myTree.insertAfter(el, lastNode);
        this.lastTreeKey = el.id;
      });
    },
    // 获取子集
    childrenData(data) {
      const { deviceId = "" } = data;
      return new Promise((resolve) => {
        this.$axios({
          method: "get",
          url: `/api/devices/${deviceId}/channels?sharePlatformId=${this.$route.params.sharePlatformId}`,
          params: {
            token: this.$cookies.get("session").token,
          },
        }).then((res) => {
          if (res && res.data.code === 0) {
            const { channelInfo = [] } = res.data.data;
            const list = channelInfo.map((el) => {
              return {
                ...el,
                label: el.channelName,
                disabled: el.isShared,
                leaf: true,
              };
            });
            resolve(list);
          }
        });
      });
    },
    // 左侧勾选
    changeLeftFn(value, data) {
      if (value) {
        this.selectedIds.push(data.id);
        this.selectedDatas.push(data);
      } else {
        this.selectedIds = this.selectedIds.filter((item) => item !== data.id);
        this.selectedDatas = this.selectedDatas.filter(
          (item) => item.id !== data.id
        );
      }
    },
    // 右侧勾选
    changeRightFn(value, data) {
      if (value) {
        this.selectedShareIds.push(data.id);
      } else {
        this.selectedShareIds = this.selectedShareIds.filter(
          (item) => item !== data.id
        );
      }
    },
    // 编辑节点
    editNode(data) {
      this.row = JSON.parse(JSON.stringify(data));
      this.showHandle = true;
    },
    // 编辑成功
    successFn() {
      this.rightPage = 1;
      this.hasRightMore = true;
      this.getShareList();
      this.showHandle = false;
    },
    // 左侧滚动
    leftScroll: debounce(function () {
      const container = this.$refs.scrollLeftContainer;
      if (!container || this.leftLoading || !this.hasLeftMore) return;

      const { scrollTop, clientHeight, scrollHeight } = container;
      const isScrollingDown = scrollTop > this.leftLastScrollTop;

      // 更新 lastScrollTop（注意：放在判断之后）
      this.leftLastScrollTop = scrollTop;

      // 只有向下滚动 + 接近底部才加载
      if (isScrollingDown && scrollHeight - scrollTop - clientHeight < 50) {
        this.leftLoading = true;
        this.leftPage += 1;
        this.getParentNode(true);
      }
    }, 100),
    // 右侧
    rightScroll: debounce(function () {
      const container = this.$refs.scrollRightContainer;
      if (!container || this.rightLoading || !this.hasRightMore) return;

      const { scrollTop, clientHeight, scrollHeight } = container;
      const isScrollingDown = scrollTop > this.rightLastScrollTop;

      // 更新 lastScrollTop（注意：放在判断之后）
      this.rightLastScrollTop = scrollTop;

      // 只有向下滚动 + 接近底部才加载
      if (isScrollingDown && scrollHeight - scrollTop - clientHeight < 10) {
        this.rightLoading = true;
        this.rightPage += 1;
        this.getShareList(true);
      }
    }, 100),
  },
};
</script>

<style scoped>
.transfer-container {
  width: 100%;
  display: flex;
  align-items: stretch;
  gap: 16px;
  background-color: #fff;
}

.transfer-panel {
  flex: 1;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  min-width: 200px;
}

.transfer-header {
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #606266;
}

.transfer-count {
  color: #909399;
}

.transfer-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
  min-height: 200px;
}

.transfer-empty {
  text-align: center;
  color: #909399;
  padding: 20px;
}

.transfer-checkbox-group {
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}

.transfer-checkbox-item {
  width: 100%;
  display: block;
  display: flex;
  align-items: center;
  padding: 4px 0;
  cursor: pointer;
  user-select: none;
  line-height: 1.5;
}

.transfer-checkbox-item input[type="checkbox"] {
  margin-right: 8px;
  vertical-align: middle;
}

.transfer-footer {
  padding: 8px 12px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.btn-link {
  background: none;
  border: none;
  color: #409eff;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
}

.btn-link:hover:not(:disabled) {
  color: #66b1ff;
  text-decoration: underline;
}

.btn-link:disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.transfer-operation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.transfer-button {
  width: 32px;
  height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  font-weight: bold;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
}

.transfer-button:hover:not(:disabled) {
  border-color: #409eff;
  color: #409eff;
}

.transfer-button:disabled {
  background: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
}

.selected {
  color: #409eff;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
}

.action_btn {
  display: block;
  margin-left: auto;
}

.loading,
.no-more {
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/Transfer/index.vue